/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ReceiptQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;

export type ReceiptQuery = {
  readonly __typename?: 'Query';
  readonly receipt:
    | { readonly __typename: 'ExpiredReceipt'; readonly errorMessage: string }
    | {
        readonly __typename: 'Receipt';
        readonly id: string;
        readonly isClaimed: boolean;
        readonly order: {
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderSource: Types.OrderSource | null;
          readonly orderType: Types.OrderType;
          readonly total: number | null;
          readonly wantedTime: string;
          readonly isPendingFeedback: boolean;
          readonly vendorId: string;
          readonly payments: ReadonlyArray<{
            readonly __typename: 'Payment';
            readonly id: string;
            readonly amountInCents: number;
            readonly processor: string;
            readonly paymentTime: string;
            readonly type: string | null;
            readonly last4: string | null;
            readonly refunded: boolean | null;
            readonly refundedAmount: number | null;
          }> | null;
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
            }>;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
              readonly ingredients: ReadonlyArray<{
                readonly __typename: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly __typename?: 'MixedDressingDetails';
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
          }>;
          readonly ledger: {
            readonly __typename?: 'Ledger';
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly address: string;
            readonly city: string;
            readonly state: string;
            readonly zipCode: string;
            readonly latitude: number;
            readonly longitude: number;
          };
        };
      }
    | { readonly __typename: 'ReceiptAlreadyClaimed'; readonly errorMessage: string }
    | { readonly __typename: 'ReceiptNotFound'; readonly errorMessage: string }
    | null;
};

export const ReceiptDocument = gql`
  query Receipt($id: String!) {
    receipt(id: $id) {
      ... on Receipt {
        __typename
        id
        isClaimed
        order {
          id
          orderSource
          orderType
          total
          wantedTime
          isPendingFeedback
          vendorId
          payments {
            __typename
            id
            amountInCents
            processor
            paymentTime
            type
            last4
            refunded
            refundedAmount
          }
          lineItems {
            id
            __typename
            slug
            quantity
            cost
            customName
            perItemCost
            favorited
            isCustom
            addedIngredients {
              id
              __typename
              name
              kind
              asset {
                url
              }
            }
            removedIngredients {
              id
              __typename
              name
              kind
              asset {
                url
              }
            }
            product {
              id
              __typename
              name
              slug
              isCustom
              asset {
                url
              }
              ingredients {
                id
                __typename
                name
                kind
              }
            }
            mixedDressingDetails {
              ingredientId
              weight
            }
            dressingMode
          }
          ledger {
            tax
            subtotal
            feesTotal
            discountsTotal
            creditsTotal
            tip
            discounts {
              id
              __typename
              name
              amount
              description
            }
            credits {
              id
              __typename
              name
              amount
              description
            }
            fees {
              id
              __typename
              name
              amount
              description
            }
          }
          restaurant {
            id
            slug
            name
            address
            city
            state
            zipCode
            latitude
            longitude
          }
        }
      }
      ... on ExpiredReceipt {
        __typename
        errorMessage
      }
      ... on ReceiptNotFound {
        __typename
        errorMessage
      }
      ... on ReceiptAlreadyClaimed {
        __typename
        errorMessage
      }
    }
  }
`;

export function useReceiptQuery(options: Omit<Urql.UseQueryArgs<ReceiptQueryVariables>, 'query'>) {
  return Urql.useQuery<ReceiptQuery, ReceiptQueryVariables>({ query: ReceiptDocument, ...options });
}
